<template>
    <div style="position: fixed; bottom: 0; width: 100%; height: 60px; background: #fff">
        <ion-progress-bar :value="progress"></ion-progress-bar>
        <div style="padding: 7px">
            <ion-row>
                <ion-col size="4" class="text-left">
                    <strong style="display: block; margin-top: 7px">Krok: {{ step }}/{{ data ? data.length : 0 }}</strong>
                </ion-col>
                <ion-col size="8" class="text-right">
                    <ion-button mode="ios"
                                fill="outline"
                                size="small"
                                @click="previousTrainingStep"
                                v-if="data && data.length > 1 && step > 1"
                                :disabled="disabledPrevButton">Poprzedni
                    </ion-button>
                    <ion-button mode="ios"
                                size="small"
                                @click="nextTrainingStep"
                                v-if="!disabledNextButton">Następny
                    </ion-button>
                    <ion-button mode="ios"
                                size="small"
                                style="--background:#1c9153"
                                @click="$emit('finish')"
                                :disabled="finish_button_disabled"
                                v-if="disabledNextButton && finish_button_label">
                        <span v-if="finish_button_loading">Czekaj...</span>
                        <span v-else>{{ finish_button_label }}</span>
                    </ion-button>
                </ion-col>
            </ion-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TabProgress',
        props: ['step','data','finish_button_loading','finish_button_label','finish_button_disabled'],
        computed: {

            // progress bar value
            progress(){
                if(this.data){
                    return this.step / this.data.length
                }else{
                    return 0
                }
            },

            // disable previous step button
            disabledPrevButton(){
                if(this.step < 2){
                    return true
                }else{
                    return false
                }
            },

            // disable next step button
            disabledNextButton(){
                if(this.data && this.step >= this.data.length){
                    return true
                }else{
                    return false
                }
            }

        },
        methods: {
            previousTrainingStep(){
                this.$parent.step--;
            },
            nextTrainingStep(){
                this.$parent.step++;
            }
        }
    }

</script>